/**
 * Route guard for "/": shows the public landing page to visitors, and skips
 * straight to the dashboard for anyone already signed in — mirrors
 * `ProtectedRoute`'s pattern but inverted (public-by-default instead of
 * protected-by-default).
 */

import { Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import useAuth from "@/hooks/useAuth";
import LandingPage from "@/pages/landing/LandingPage";

export function HomeRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <LandingPage />;
}

export default HomeRoute;
